import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {useAuth} from './useAuth';

function useRedirectAuth() {
  const {isLoggedIn} = useAuth();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  useEffect(
    function redirectIfLoggedIn() {
      if (isLoggedIn) {
        navigate(getFullPath(PATHS.home));
      }
    },
    [isLoggedIn, navigate, getFullPath],
  );
}

export {useRedirectAuth};
